import { Cache } from '@stt-componentes/cache';
import { signal } from "@preact/signals-react";

export const getHeaders = () => {
	const token = Cache.getAccessToken();
	return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
};

export const getAuthorization = () => {
	const token = Cache.getAccessToken();
	return `Bearer ${token}`;
};

export const pesquisaAvancada = signal(false);

export const setPesquisaAvancada = () => {
    pesquisaAvancada.value = !pesquisaAvancada.value;
};